import React from 'react';
import ReactDOM,{hydrateRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import './Assets/plugins/lightgallery.js/dist/css/lightgallery.min.css';
import './Assets/plugins/flickity/dist/flickity.min.css';
import './Assets/css/theme.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'aos/dist/aos.css'; ;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


